export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    color: theme.custom.colors.text,
  },

  extraAttr: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.custom.colors.text,
  },

  btnWrapper: {
    position: 'relative',
  },

  cancelButton: {
    backgroundColor: theme.custom.colors.cancelButton,
    color: '#FFF',
  },

  saveButton: {
    backgroundColor: theme.custom.colors.confirmButton,
    color: '#FFF',
  },

  editButton: {
    backgroundColor: theme.custom.colors.editButton,
    color: '#FFF',
  },

  buttonProgress: {
    color: theme.custom.colors.confirmButton,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});
